export const DebugOn = true;
export const THEME = 'primary';
export const LibraryTag = 'FusionUI';

export const DefStr = "";
export const DefStrNA = "N/A";
export const DefStrNAPlain = "NA";

export const GL_PANEL_SECTION_CLS = "section height w-100 p-1 m-0";
export const GL_PANEL_SECTION_BORDERLESS_CLS = `${GL_PANEL_SECTION_CLS} borderless`;

export const FormInputCls = {
    _1_12: `col-sm-12 col-md-1 px-2 pb-1`,
    _2_12: `col-sm-12 col-md-2 px-2 pb-1`,
    _3_12: `col-sm-12 col-md-3 px-2 pb-1`,
    _4_12: `col-sm-12 col-md-4 px-2 pb-1`,
    _5_12: `col-sm-12 col-md-5 px-2 pb-1`,
    _6_12: `col-sm-12 col-md-6 px-2 pb-1`,
    _7_12: `col-sm-12 col-md-7 px-2 pb-1`,
    _8_12: `col-sm-12 col-md-8 px-2 pb-1`,
    _9_12: `col-sm-12 col-md-9 px-2 pb-1`,
    _10_12: `col-sm-12 col-md-10 px-2 pb-1`,
    _11_12: `col-sm-12 col-md-11 px-2 pb-1`,
    _12_12: `col-sm-12 col-md-12 px-2 pb-1`,
};
export const CssVariant = {
    primary: 'primary',
    primaryDark: 'primaryDark',
    success: 'success',
    secondary: 'secondary',
    warning: 'warning',
    info: 'info',
    dark: 'dark',
    light: 'light',
    danger: 'danger',
    white: 'white',
};
export const FsVarVariant = {
    XS: "var(--fs-xs)",
    MD_XS: "var(--fs-md-xs)",
    SM: "var(--fs-sm)",
    MD_SM: "var(--fs-md-sm)",
    NORMAL: "var(--fs-normal)",
    MD: "var(--fs-md)",
    SM_MD: "var(--fs-sm-md)",
    MD_LG: "var(--fs-md-lg)",
    LG: "var(--fs-lg)",
    XL: "var(--fs-xl)",
    XXL: "var(--fs-xxl)",
    XXXL: "var(--fs-xxxl)",
    XXXXL: "var(--fs-xxxxl)",
    XXXXXL: "var(--fs-xxxxxl)",
    XXXXXXL: "var(--fs-xxxxxxl)",
};
export const RippleVarVariant = {
    normal: "var(--ripple-color)",
    dark: "var(--ripple-color)",
    light: "var(--ripple-color-light)",
    primary: "var(--ripple-color-primary)",
    success: "var(--ripple-color-success)",
    danger: "var(--ripple-color-danger)",
    info: "var(--ripple-color-info)",
    secondary: "var(--ripple-color-secondary)",
};
export const Messages = {
    offlineError: "Error: Server is either offline or trying to connect to the wrong port! ",
    _413Error: "Error Code = 413, Perhaps request entity too large (See: PayloadTooLargeError)",

    formDataSaveSuccess: "You data has been saved successfully",
    fetchSuccess: "Data loaded successfully",
    fetchError: "Couldn't load data, please try again!",
    saveError: "Couldn't save your data, please try again",
    formDataSaveError: "Couldn't save your data, please try again",
    emptyField: "This field is required.", // Field cannot be empty
    alphabeticValue: "*Alphabetic characters only",
    alphaNumericValue: "*Alphanumeric characters only",
    numericValue: "*Numeric values only",
    invalidUrl: "*Invalid Url",
    invalidEmail: "*Invalid Email",
    invalidMobile: "*Invalid Mobile",
    invalidValue: "*Invalid data",
    noDataFound: "No data found!",
    noRecordsFound: "Records not found!",
    invalidPassword: "Should have at least 1 uppercase, 3 lowercase, 2 digits, 1 special symbol, min-length=8",
};
export const IconClass = {
    globe: "bi bi-globe",
    youtube: "bi bi-youtube",
    linkedin: "bi bi-linkedin",
    twitter: "bi bi-twitter", // twitter: "bi bi-twitter-x",
    allSm: "bi bi-graph-down",
    instagram: "bi bi-instagram",
    facebook: "bi bi-facebook",
    bookmark: "bi bi-bookmarks",
    favourite: "bi bi-star",
    favouriteFill: "bi bi-star-fill",
    bookmarkFill: "bi bi-bookmarks-fill",
    engagement: "bi bi-intersect",
    interaction: "bi bi-pie-chart",
    note: "bi bi-card-text",
    printer: "bi bi-printer",
    printerFill: "bi bi-printer-fill",
    edit: "bi bi-pencil",
    edit2: "bi bi-pencil-square",
    columns: "bi bi-layout-three-columns",
    delete: "bi bi-trash",
    circle: "bi bi-circle",
    circleFill: "bi bi-circle-fill",
    search: "bi bi-search",
    searchBold: "fa fa-search",
    eye: "bi bi-eye",
    eyeFill: "bi bi-eye-fill",
    eyeSlash: "bi bi-eye-slash",
    eyeSlashFill: "bi bi-eye-slash-fill",
    sliders: "bi bi-sliders",
    filter: "bi bi-filter",
    funnel: "bi bi-funnel",
    funnelFill: "bi bi-funnel-fill",
    layoutColGap: "bi bi-columns-gap",
    layoutCol: "bi bi-columns",
    bars: "bi bi-list",
    grid: "bi bi-grid-fill",
    download: "bi bi-download",
    sortAZ: "bi bi-sort-alpha-up",
    sortZA: "bi bi-sort-alpha-down-alt",
    sortAsc: "bi bi-sort-down-alt",
    save: "fa fa-floppy-o",
    saveFill: "bi bi-floppy-fill",
    sortDesc: "bi bi-sort-down",
    copy: "fa fa-clone",
    copy2: "fa fa-files-o",
    rowsColumns: "bi bi-list-columns-reverse",
    doubleCheck: "bi bi-check-all",
    clipboard: "bi bi-clipboard",
    excel: "bi bi-file-earmark-excel",
    excel2: "fa fa-file-excel-o",
    sidebar: "bi bi-layout-sidebar",
    table: "bi bi-table",
    graph: "bi bi-bounding-box",
    app: "bi bi-app-indicator",
    ok: "bi bi-check-lg",
    check: "bi bi-check-lg",
    check2: "bi bi-check2",
    checkAll: "bi bi-check-all",
    check2All: "bi bi-check2-all",
    checkCircle: "bi bi-check-circle",
    checkCircleFill: "bi bi-check-circle-fill",
    close: "bi bi-x",
    closeCircle: "bi bi-x-circle",
    closeOctagon: "bi bi-x-octagon",
    refresh: "bi bi-arrow-clockwise",
    refreshLg: "fa fa-refresh",
    restore: "bi bi-arrow-clockwise",
    arrowLeft: "bi bi-arrow-left",
    arrowRight: "bi bi-arrow-right",
    arrowDown: "bi bi-arrow-down",
    arrowUp: "bi bi-arrow-up",
    angleDown: "fa fa-angle-down",
    angleUp: "fa fa-angle-up",
    plus: "bi bi-plus",
    plusCircle: "bi bi-plus-circle",
    minusCircle: "bi bi-dash-circle",
    heart: "bi bi-suit-heart",
    heartFill: "bi bi-suit-heart-fill",
    share: "fa fa-share",
    comment: "fa fa-comment-o",
    calenderEvent: "bi bi-calendar2-event",
    like: "bi bi-hand-thumbs-up",
    likeFill: "bi bi-hand-thumbs-up-fill", // like: "fa fa-thumbs-o-up",
    // likeFill: "fa fa-thumbs-up",
    star: "bi bi-star",
    starFill: "bi bi-star-fill",
    bell: "bi bi-bell",
    playButton: "bi bi-play-circle",
    menuVertical: "bi bi-three-dots-vertical",
    fullScreen: "bi bi-arrows-fullscreen",
    iButton: "bi bi-info-circle",
    iButtonFill: "bi bi-info-circle-fill",
    logout: "bi bi-box-arrow-right",
    personCircle: "bi bi-person-circle",
};
export const Patterns = {
    plainNumber: /^[0-9]*$/,
    allNumber: /^\-?\d+((\.)\d+)?$/,
    emailMobText: /^[a-zA-Z\s]*$/, // plainText: /^[a-zA-Z\s]*$/,
    emailStandard: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    mobStandard: /[^0-9\s\-+ ]/g,
    plainText: /^[a-zA-Z\ ]*$/, // plainText: /^[A-Za-z\s_\-]+$/,
    simpleText: /^[a-zA-Z\]*$/, // plainText: /^[A-Za-z\s_\-]+$/,
    /**
     * One uppercase letter, two digits, three lowercase letters, min-length=8
     */
    password: /^(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9].*[0-9])(?=.*[a-z].*[a-z].*[a-z]).{8,}$/,
    prefix: /^[a-zA-Z\s.\-]+$/,

    // email: /^[a-zA-Z0-9.!#$%&'*+/:?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
    email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, // mobile: /^(\+?\d{1,3})?[-.\s]?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/,
    // mobile: /^\+\d{1,14}-\d{1,}$/,
    mobile: /^[0-9]*$/,
    mobileWithCountryCode: /^[\d+ ]{0,14}$/,
    // mobileWithCountryCodeAdvance: /^[+-]?[0-9]{10,14}$/,
    mobileWithCountryCodeAdvance: /^[+-]?[0-9]{10,14}$/,
    pincode: /^[0-9]*$/,
    skills: /^[a-zA-Z\. \-\,\(\)\#\@\/\n]*$/,
    file: /^([a-zA-Z]:)?((\/|\\)[^<>:"/\\|?*\n\r]+)+(\.|\/|\\)([^<>:"/\\|?*\n\r]+)*$/,
    alphaNumeric: /^[a-zA-Z0-9]+$/,
    url: /^(http(s)?:\/\/)?([w]{3}\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})(\/[a-zA-Z0-9-_#]+)*\/?(\?[a-zA-Z0-9-_#]+=[a-zA-Z0-9-%]+(&[a-zA-Z0-9-_#]+=[a-zA-Z0-9-%]+)*)?$/,
    imageUrl: /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})(\/[^\s]*)?\.(jpg|jpeg|png|gif|bmp|svg)$/i,
    fax: /^\+?[0-9\s-]+$/,
    message: /^[\w\s.,!?@#$%^&*()-+=<>[\]{}|\\/]+$/, // message: /^[\w\s\-.,!@()/&]+$/,
    unicodeStr: /^[\w\s,()&\-\/.\\]+$/,
    address: /^[a-zA-Z0-9 ,.\-_/\\]+$/,
    msgAdvance: /[^a-zA-Z0-9\s\.,?!:;'"()-]/g,
    commaDashUnderscoreSpaceStr: /^[a-zA-Z\s, -]+$/, // message: /^[a-zA-Z0-9\. \-\,\(\)\#\@\/\n]*$/,
};
export const Constants = {
    userVectorDark: "https://cdn.pixabay.com/photo/2016/08/31/11/54/icon-1633249_1280.png",
    userVectorGaped: "https://cdn.pixabay.com/photo/2012/04/26/19/43/profile-42914_1280.png",
    imgVector: "https://cdn.pixabay.com/photo/2017/11/10/04/47/image-2935360_1280.png",
    userVector: "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png",
    docVector: 'https://cdn.pixabay.com/photo/2014/05/26/09/44/icon-354343_1280.png',
    formUploadDur: 1000,
    errorTimeout: 2500,
    acceptedCSVFormats: "application/csv",
    waitExtraShort: 300,
    waitShort: 700,
    wait: 1000,
    waitLong: 1500,
    waitExtraLong: 2500,
    logFetchGap: 10000,
    logLimit: 100,
    dateFormat: `DD-MM-YYYY`,
    YYYY_MM_DD_DASH: "YYYY-MM-DD",
    YYYY_MMM_DD_DASH: "YYYY-MMM-DD",
    DD_MMM_YYYY_DASH: "DD-MMM-yyyy",
    DD_MMM_YYYY_DASH_HMSA: "DD-MMM-yyyy hh:mm:ssA",
    YYYY_MM_DD_DASH_HMS: "YYYY-MM-DD HH:mm:ss",
    DD_MMM_YYYY_UNDERSCORE: "DD_MMM_yyyy",
    DD_MMM_YYYY_SLASH: "DD/MMM/yyyy",
    DD_MM_YYYY_DASH: "DD-MM-YYYY",
    DD_MM_YYYY_SLASH: "DD/MM/YYYY",
    acceptedResumeFormats: "application/pdf, application/docx",
    imageFormats: "image/*",
};
export const ScreenSizes = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400,
};
export const HonorificsPrefixes = [
    "Mrs.",
    "Mrs",
    "Ms.",
    "Ms",
    "Mr.",
    "Mr",
    "Mx.",
    "Mx",
    "Miss.",
    "Miss",
    "Dr.",
    "Dr",
    "Prof.",
    "Prof",
    "Captain",
    "Capt.",
    "Cap.",
    "Sir",
    "Dame",
    "Lord",
    "Lady",
    "Count",
    "Countess",
    "Rabbi",
    "Imam",
    "Pastor",
    "Reverend",
    "Rev.",
    "Sister",
    "Brother",
    "And",
];
export const DurationUnits = {
    //s: Seconds,  m: Minutes,  h: Hours,  d: Days,  w: Weeks,  M: Months,  y: Years
    mn: {unit: 'Minute', max: 60, repr: 'm'},
    hr: {unit: 'Hour', max: 24, repr: 'h'},
    dy: {unit: 'Day', max: 30, repr: 'd'},
    wk: {unit: 'Week', max: 52, repr: 'w'},
    mnth: {unit: 'Month', max: 12, repr: 'M'},
    yr: {unit: 'Year', max: 4, repr: 'y'}
};
